// extracted by mini-css-extract-plugin
module.exports = {"flex":"PostCommentInReviewMessage-flex-3e2DL","buttonWrapper":"PostCommentInReviewMessage-buttonWrapper-YNREN"};